import { render, staticRenderFns } from "./EVoucherWaitForApproval.vue?vue&type=template&id=2f202dc5&scoped=true&"
import script from "./EVoucherWaitForApproval.vue?vue&type=script&lang=js&"
export * from "./EVoucherWaitForApproval.vue?vue&type=script&lang=js&"
import style0 from "./EVoucherWaitForApproval.vue?vue&type=style&index=0&id=2f202dc5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f202dc5",
  null
  
)

export default component.exports